import { isEmpty } from "./matchers/matchers.js";
//#region src/utils/routes.ts
var combineRoutes = (...routes) => {
	return `${routes.filter((route) => route.trim() !== "").join("")}`;
};
var isRoute = (route, currentPath) => {
	return currentPath.includes(route);
};
var getMatchedRoutes = (matches) => {
	const filteredRoutes = {};
	if (matches && Array.isArray(matches)) matches.forEach((match) => {
		if (!isEmpty(match) && !isEmpty(match.handle?.routes)) filteredRoutes.routes = match.handle?.routes;
	});
	return filteredRoutes?.routes;
};
var getLastSegment = (pathName) => {
	const segments = pathName.split("/");
	return `/${segments[segments.length - 1]}`;
};
var getMatchedFunctions = (matches) => {
	const matchedFunctions = {};
	if (matches && Array.isArray(matches)) matches.forEach((match) => {
		if (!isEmpty(match) && !isEmpty(match.handle?.functions)) matchedFunctions.functions = match.handle?.functions;
	});
	return matchedFunctions?.functions;
};
//#endregion
export { combineRoutes, getLastSegment, getMatchedFunctions, getMatchedRoutes, isRoute };

//# sourceMappingURL=routes.js.map